import { ACTION_TYPE } from "../actions/fixProblemPicAction";

const initState = {
  fixProblemPic: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case ACTION_TYPE.SET_OPER_JOB_PIC:
      return {
        ...state,
        fixProblemPic: action.payload,
      };
    default:
      return state;
  }
};
